import { render, staticRenderFns } from "./ElementalArts.vue?vue&type=template&id=275a6a40&scoped=true"
import script from "./ElementalArts.vue?vue&type=script&lang=js"
export * from "./ElementalArts.vue?vue&type=script&lang=js"
import style0 from "./ElementalArts.vue?vue&type=style&index=0&id=275a6a40&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "275a6a40",
  null
  
)

export default component.exports